"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linkedin = Linkedin;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function Linkedin(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M20.4696 1.9999H3.52957C3.33915 1.99725 3.15007 2.03214 2.97314 2.10258C2.7962 2.17302 2.63487 2.27762 2.49837 2.41041C2.36186 2.5432 2.25285 2.70158 2.17756 2.87651C2.10227 3.05143 2.06218 3.23947 2.05957 3.4299V20.5699C2.06218 20.7603 2.10227 20.9484 2.17756 21.1233C2.25285 21.2982 2.36186 21.4566 2.49837 21.5894C2.63487 21.7222 2.7962 21.8268 2.97314 21.8972C3.15007 21.9676 3.33915 22.0025 3.52957 21.9999H20.4696C20.66 22.0025 20.8491 21.9676 21.026 21.8972C21.2029 21.8268 21.3643 21.7222 21.5008 21.5894C21.6373 21.4566 21.7463 21.2982 21.8216 21.1233C21.8969 20.9484 21.937 20.7603 21.9396 20.5699V3.4299C21.937 3.23947 21.8969 3.05143 21.8216 2.87651C21.7463 2.70158 21.6373 2.5432 21.5008 2.41041C21.3643 2.27762 21.2029 2.17302 21.026 2.10258C20.8491 2.03214 20.66 1.99725 20.4696 1.9999ZM8.08957 18.7399H5.08957V9.7399H8.08957V18.7399ZM6.58957 8.4799C6.17583 8.4799 5.77904 8.31554 5.48648 8.02298C5.19393 7.73043 5.02957 7.33363 5.02957 6.9199C5.02957 6.50616 5.19393 6.10937 5.48648 5.81681C5.77904 5.52425 6.17583 5.3599 6.58957 5.3599C6.80927 5.33498 7.03175 5.35675 7.24245 5.42378C7.45314 5.49081 7.64731 5.60159 7.81223 5.74886C7.97715 5.89613 8.1091 6.07657 8.19944 6.27838C8.28979 6.48018 8.33649 6.69879 8.33649 6.9199C8.33649 7.141 8.28979 7.35961 8.19944 7.56141C8.1091 7.76322 7.97715 7.94366 7.81223 8.09093C7.64731 8.23821 7.45314 8.34898 7.24245 8.41601C7.03175 8.48304 6.80927 8.50481 6.58957 8.4799ZM18.9096 18.7399H15.9096V13.9099C15.9096 12.6999 15.4796 11.9099 14.3896 11.9099C14.0522 11.9124 13.7238 12.0182 13.4484 12.2131C13.1731 12.408 12.9641 12.6826 12.8496 12.9999C12.7713 13.2349 12.7374 13.4825 12.7496 13.7299V18.7299H9.74957C9.74957 18.7299 9.74957 10.5499 9.74957 9.7299H12.7496V10.9999C13.0221 10.527 13.4185 10.1374 13.896 9.8731C14.3735 9.60878 14.9141 9.47975 15.4596 9.4999C17.4596 9.4999 18.9096 10.7899 18.9096 13.5599V18.7399Z",
    fill: "currentColor"
  }));
}

Linkedin.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Linkedin"
};